import { Injectable, Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LOCAL_STORAGE , StorageService } from 'angular-webstorage-service';
import * as momentImported from 'moment'; const moment = momentImported;
import { DconfigCoreSettings } from '../dconfig-core.settings';

const TOKEN_KEY = 'TOKEN';
const USERNAME_KEY = 'USERNAME';
const EXPIRES_AT_KEY = 'EXPIRES_AT';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {
  private _authentication = {
    isAuth: false,
    userName: "",
    token: ""
  };

  public _401Handler; // A pointer to 401 exception handler 
  public _403Handler; // A pointer to 403 exception handler

  constructor(private http: HttpClient, @Inject(LOCAL_STORAGE) private storage: StorageService) { }

  login(loginData, successHandler, errorHandler) {
    var data = "grant_type=password&username=" + encodeURIComponent(loginData.userName) + "&password=" + encodeURIComponent(loginData.password);
    //var deferred = $q.defer();    
    this.http.post(DconfigCoreSettings.API_ENDPOINT + '/token', data).subscribe((response) => {
      if (response === undefined || response["access_token"] === undefined) {
        errorHandler("Undefined response");
      }
      this.setSession({ token: response['access_token'], userName: response['username'], expiresIn: response['expires_in'] });
      successHandler(response);
    }, (reason) => {
      this.logout();
      errorHandler(reason);
    });
  };

  private setSession(authResult) {
    const expiresAt = moment().add(authResult.expiresIn, 'seconds');
    this.storage.set(TOKEN_KEY, authResult.token);
    this.storage.set(USERNAME_KEY, authResult.userName);
    this.storage.set(EXPIRES_AT_KEY, JSON.stringify(expiresAt.valueOf()));
  }          


  logout() {
    this.storage.remove(TOKEN_KEY);
    this.storage.remove(USERNAME_KEY);
    this.storage.remove(EXPIRES_AT_KEY);
  }

  isAuth() {
    return moment().isBefore(this.getExpiration());
  }

  getToken() {
    return this.storage.get(TOKEN_KEY);
  }

  getUserName() {
    return this.storage.get(USERNAME_KEY);
  }

  getExpiration() {
    const expiration = this.storage.get(EXPIRES_AT_KEY);
    const expiresAt = JSON.parse(expiration);
    return moment(expiresAt);
  }  

  set401Action(handler): void {
    this._401Handler = handler;
  }

  set403Action(handler): void {
    this._403Handler = handler;
  }
}
